// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_onboarding.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse, MultiGenericPayloadResponse } from "./stcs_commons.entity";
import { DmCompAccDataUploadRequest } from "./stcs_wapp_svc_dm";

export const protobufPackage = "stcs_cmw";

export interface OnboardingCompleteAccMappingRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface OnboardingCompleteFsdRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OnboardingPauseRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OnboardingResumeRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OnboardingSimulatePaymentRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OnboardingCompleteRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OnboardingConfirmWelcomeRequest {
  ref_id_user: string;
  ref_id_org: string;
}

function createBaseOnboardingCompleteAccMappingRequest(): OnboardingCompleteAccMappingRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const OnboardingCompleteAccMappingRequest: MessageFns<OnboardingCompleteAccMappingRequest> = {
  encode(message: OnboardingCompleteAccMappingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingCompleteAccMappingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingCompleteAccMappingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingCompleteAccMappingRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: OnboardingCompleteAccMappingRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingCompleteAccMappingRequest>, I>>(
    base?: I,
  ): OnboardingCompleteAccMappingRequest {
    return OnboardingCompleteAccMappingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingCompleteAccMappingRequest>, I>>(
    object: I,
  ): OnboardingCompleteAccMappingRequest {
    const message = createBaseOnboardingCompleteAccMappingRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseOnboardingCompleteFsdRequest(): OnboardingCompleteFsdRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OnboardingCompleteFsdRequest: MessageFns<OnboardingCompleteFsdRequest> = {
  encode(message: OnboardingCompleteFsdRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingCompleteFsdRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingCompleteFsdRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingCompleteFsdRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OnboardingCompleteFsdRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingCompleteFsdRequest>, I>>(base?: I): OnboardingCompleteFsdRequest {
    return OnboardingCompleteFsdRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingCompleteFsdRequest>, I>>(object: I): OnboardingCompleteFsdRequest {
    const message = createBaseOnboardingCompleteFsdRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOnboardingPauseRequest(): OnboardingPauseRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OnboardingPauseRequest: MessageFns<OnboardingPauseRequest> = {
  encode(message: OnboardingPauseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingPauseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingPauseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingPauseRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OnboardingPauseRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingPauseRequest>, I>>(base?: I): OnboardingPauseRequest {
    return OnboardingPauseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingPauseRequest>, I>>(object: I): OnboardingPauseRequest {
    const message = createBaseOnboardingPauseRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOnboardingResumeRequest(): OnboardingResumeRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OnboardingResumeRequest: MessageFns<OnboardingResumeRequest> = {
  encode(message: OnboardingResumeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingResumeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingResumeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingResumeRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OnboardingResumeRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingResumeRequest>, I>>(base?: I): OnboardingResumeRequest {
    return OnboardingResumeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingResumeRequest>, I>>(object: I): OnboardingResumeRequest {
    const message = createBaseOnboardingResumeRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOnboardingSimulatePaymentRequest(): OnboardingSimulatePaymentRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OnboardingSimulatePaymentRequest: MessageFns<OnboardingSimulatePaymentRequest> = {
  encode(message: OnboardingSimulatePaymentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingSimulatePaymentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingSimulatePaymentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingSimulatePaymentRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OnboardingSimulatePaymentRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingSimulatePaymentRequest>, I>>(
    base?: I,
  ): OnboardingSimulatePaymentRequest {
    return OnboardingSimulatePaymentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingSimulatePaymentRequest>, I>>(
    object: I,
  ): OnboardingSimulatePaymentRequest {
    const message = createBaseOnboardingSimulatePaymentRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOnboardingCompleteRequest(): OnboardingCompleteRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OnboardingCompleteRequest: MessageFns<OnboardingCompleteRequest> = {
  encode(message: OnboardingCompleteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingCompleteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingCompleteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingCompleteRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OnboardingCompleteRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingCompleteRequest>, I>>(base?: I): OnboardingCompleteRequest {
    return OnboardingCompleteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingCompleteRequest>, I>>(object: I): OnboardingCompleteRequest {
    const message = createBaseOnboardingCompleteRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOnboardingConfirmWelcomeRequest(): OnboardingConfirmWelcomeRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OnboardingConfirmWelcomeRequest: MessageFns<OnboardingConfirmWelcomeRequest> = {
  encode(message: OnboardingConfirmWelcomeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingConfirmWelcomeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingConfirmWelcomeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingConfirmWelcomeRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OnboardingConfirmWelcomeRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnboardingConfirmWelcomeRequest>, I>>(base?: I): OnboardingConfirmWelcomeRequest {
    return OnboardingConfirmWelcomeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnboardingConfirmWelcomeRequest>, I>>(
    object: I,
  ): OnboardingConfirmWelcomeRequest {
    const message = createBaseOnboardingConfirmWelcomeRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

export interface StcsWappSvcOnboarding {
  onboarding_complete(
    request: DeepPartial<OnboardingCompleteRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  onboarding_complete_acc_mapping(
    request: DeepPartial<OnboardingCompleteAccMappingRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  onboarding_complete_data_upload(
    request: DeepPartial<DmCompAccDataUploadRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  onboarding_complete_fsd(
    request: DeepPartial<OnboardingCompleteFsdRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  onboarding_confirm_welcome(
    request: DeepPartial<OnboardingConfirmWelcomeRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  onboarding_pause(
    request: DeepPartial<OnboardingPauseRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  onboarding_resume(
    request: DeepPartial<OnboardingResumeRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  onboarding_simulate_payment(
    request: DeepPartial<OnboardingSimulatePaymentRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
}

export class StcsWappSvcOnboardingClientImpl implements StcsWappSvcOnboarding {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.onboarding_complete = this.onboarding_complete.bind(this);
    this.onboarding_complete_acc_mapping = this.onboarding_complete_acc_mapping.bind(this);
    this.onboarding_complete_data_upload = this.onboarding_complete_data_upload.bind(this);
    this.onboarding_complete_fsd = this.onboarding_complete_fsd.bind(this);
    this.onboarding_confirm_welcome = this.onboarding_confirm_welcome.bind(this);
    this.onboarding_pause = this.onboarding_pause.bind(this);
    this.onboarding_resume = this.onboarding_resume.bind(this);
    this.onboarding_simulate_payment = this.onboarding_simulate_payment.bind(this);
  }

  onboarding_complete(
    request: DeepPartial<OnboardingCompleteRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_completeDesc,
      OnboardingCompleteRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_complete_acc_mapping(
    request: DeepPartial<OnboardingCompleteAccMappingRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_complete_acc_mappingDesc,
      OnboardingCompleteAccMappingRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_complete_data_upload(
    request: DeepPartial<DmCompAccDataUploadRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_complete_data_uploadDesc,
      DmCompAccDataUploadRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_complete_fsd(
    request: DeepPartial<OnboardingCompleteFsdRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_complete_fsdDesc,
      OnboardingCompleteFsdRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_confirm_welcome(
    request: DeepPartial<OnboardingConfirmWelcomeRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_confirm_welcomeDesc,
      OnboardingConfirmWelcomeRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_pause(
    request: DeepPartial<OnboardingPauseRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_pauseDesc,
      OnboardingPauseRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_resume(
    request: DeepPartial<OnboardingResumeRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_resumeDesc,
      OnboardingResumeRequest.fromPartial(request),
      metadata,
    );
  }

  onboarding_simulate_payment(
    request: DeepPartial<OnboardingSimulatePaymentRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOnboardingonboarding_simulate_paymentDesc,
      OnboardingSimulatePaymentRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcOnboardingDesc = { serviceName: "stcs_cmw.StcsWappSvcOnboarding" };

export const StcsWappSvcOnboardingonboarding_completeDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_complete",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingCompleteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_complete_acc_mappingDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_complete_acc_mapping",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingCompleteAccMappingRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_complete_data_uploadDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_complete_data_upload",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAccDataUploadRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_complete_fsdDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_complete_fsd",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingCompleteFsdRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_confirm_welcomeDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_confirm_welcome",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingConfirmWelcomeRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_pauseDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_pause",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingPauseRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_resumeDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_resume",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingResumeRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOnboardingonboarding_simulate_paymentDesc: UnaryMethodDefinitionish = {
  methodName: "onboarding_simulate_payment",
  service: StcsWappSvcOnboardingDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OnboardingSimulatePaymentRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
